import { useEffect } from "react";
import { useNavigate } from "react-router-dom"

import { generateShareLink } from "../../Helpers/ShareHelper";

import styles from './ChamProjects.module.css'

// Base component wrapper
export default function ChamProjects({ children }) {
    const navigate = useNavigate();

    useEffect(() => {
        // Open project
        document.querySelector('cham-projects').addEventListener('gotoviz', function (e) {
            document.querySelector('cham-projects').setAttribute("active", "0");
            navigate('/shared/'+e.value.aux1.split("/").pop());
        });

    }, [navigate]);

    return (
        <cham-projects styles={styles.chamProjects}>{children}</cham-projects>
    );
}

// Open projects dialog button
export function ChamProjectsOpenButton({ className, title }) {

    const handleClick = function () {
        document.querySelector('cham-projects').setAttribute("active", "1");
        document.querySelector('cham-projects').showProjects();
    }

    return (
        <button onClick={handleClick} className={className}>{title}</button>
    )
}

// Saves project button
export function ChamProjectsSaveButton({ className, title }) {

    const handleClick = function () {
        generateShareLink().then(result => {
            document.querySelector('cham-projects').saveProject(result.specifier, result.sel, result.url, "");
        })
    }

    return (
        <button onClick={handleClick} className={className}>{title}</button>
    )
}